/**
 * Promo Bar – Slider with forward/back arrows & swipe
 *
 * On all screen sizes:
 *  - Shows one slide at a time (full width)
 *  - Auto-rotates every 7s (ping-pong direction)
 *  - Forward arrow (right) visible on slide 0..N-2
 *  - Back arrow (left) visible on slide 1..N-1
 *  - Swipe left/right to navigate manually
 */
(function () {
    'use strict';

    var INTERVAL = 7000;
    var SWIPE_THRESHOLD = 40;

    function init() {
        var container = document.querySelector('.promo-bar__container');
        if (!container) return;

        var items = container.querySelectorAll('.promo-bar__item');
        if (items.length <= 1) return;

        var currentIndex = 0;
        var direction = 1;
        var timer = null;
        var touchStartX = 0;

        var chevronRight = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
        var chevronLeft = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';

        // Forward arrow (right side)
        var arrowNext = document.createElement('span');
        arrowNext.className = 'promo-bar__arrow promo-bar__arrow--next';
        arrowNext.setAttribute('aria-label', 'Next');
        arrowNext.innerHTML = chevronRight;
        container.appendChild(arrowNext);

        // Back arrow (left side)
        var arrowPrev = document.createElement('span');
        arrowPrev.className = 'promo-bar__arrow promo-bar__arrow--prev';
        arrowPrev.setAttribute('aria-label', 'Previous');
        arrowPrev.innerHTML = chevronLeft;
        container.appendChild(arrowPrev);

        function updateSlide() {
            var offset = -currentIndex * 100;
            for (var i = 0; i < items.length; i++) {
                items[i].style.transform = 'translateX(' + offset + '%)';
            }
            updateArrows();
        }

        function updateArrows() {
            // Show/hide forward arrow
            if (currentIndex >= items.length - 1) {
                arrowNext.classList.add('is-hidden');
            } else {
                arrowNext.classList.remove('is-hidden');
            }
            // Show/hide back arrow
            if (currentIndex <= 0) {
                arrowPrev.classList.add('is-hidden');
            } else {
                arrowPrev.classList.remove('is-hidden');
            }
        }

        function goTo(index) {
            if (index < 0) index = 0;
            if (index >= items.length) index = items.length - 1;
            currentIndex = index;
            direction = (currentIndex >= items.length - 1) ? -1 : 1;
            updateSlide();
        }

        function advance() {
            if (currentIndex + direction >= items.length) {
                direction = -1;
            } else if (currentIndex + direction < 0) {
                direction = 1;
            }
            currentIndex += direction;
            updateSlide();
        }

        function startRotation() {
            stopRotation();
            updateSlide();
            timer = setInterval(advance, INTERVAL);
        }

        function stopRotation() {
            if (timer) {
                clearInterval(timer);
                timer = null;
            }
        }

        // Forward arrow click
        arrowNext.addEventListener('click', function (e) {
            e.preventDefault();
            stopRotation();
            goTo(currentIndex + 1);
            setTimeout(startRotation, 2000);
        });

        // Back arrow click
        arrowPrev.addEventListener('click', function (e) {
            e.preventDefault();
            stopRotation();
            goTo(currentIndex - 1);
            setTimeout(startRotation, 2000);
        });

        // Swipe support
        container.addEventListener('touchstart', function (e) {
            touchStartX = e.touches[0].clientX;
            stopRotation();
        }, { passive: true });

        container.addEventListener('touchend', function (e) {
            var diff = touchStartX - e.changedTouches[0].clientX;
            if (Math.abs(diff) > SWIPE_THRESHOLD) {
                goTo(currentIndex + (diff > 0 ? 1 : -1));
            }
            setTimeout(startRotation, 2000);
        }, { passive: true });

        // Start immediately
        startRotation();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
